import React from 'react';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody  } from 'reactstrap';
import { withAlert } from 'react-alert'
import { connect } from 'react-redux'

class DeletePrintDestinationModal extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            ...props
        }

        this.attemptDelete = this.attemptDelete.bind(this) 
    }

    attemptDelete() 
    {
      //Set document to status deleted in archive
      fetch(window.location.protocol + '//' + window.location.host + '/api/printing/x3printers?id='+this.props.name,{
        method: 'DELETE'
      })
      .then(result => 
      {
        this.props.refresh()
        this.props.toggle()
        this.props.alert.success("Deleted destination.");
      })
      .catch(error=>
      {
        //need to log the error
        this.props.alert.error('An error occurred whilst attemping document deletion ' + error);
        
      });
    }

    render() {

        const { localisation } = this.props.userReducer;

        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggle} className='modal-dialog'>
                <ModalHeader toggle={this.props.toggle}>{localisation['delete_print_destination_header'] ? localisation['delete_print_destination_header'].element_lang : ''}</ModalHeader>
                <ModalBody>
                  {localisation['delete_print_destination_confirmation_text'] ? localisation['delete_print_destination_confirmation_text'].element_lang +': ' + this.props.name +'?' : '' + this.props.name}
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={this.attemptDelete}>Delete</Button>
                    <Button id="cancelButton" color="secondary" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default connect(state => state)(withAlert()(DeletePrintDestinationModal));